import {responsiveFontSize} from "react-native-responsive-dimensions";
import {hexToRGB} from "../services/helpers/stylingHelpers";

export const MARGIN_VALUE = 12.5
export const MARGIN_VALUE_LANDSCAPE = 12.5 / 2
export const MAX_WIDTH_VALUE = 100 - 2 * MARGIN_VALUE

// COLOR
export const COLOR_RED = '#ff0000'
export const COLOR_GREEN = '#00ff00'
export const COLOR_BLUE = '#0000FF'
export const COLOR_WHITE = '#FFFFFF'
export const COLOR_BLACK = '#000000'

export const TEXT_PRIMARY_COLOR = "#515151"
export const SUBTEXT_PRIMARY_COLOR = "#838383"

export const FONT_SIZE_XS = responsiveFontSize(0.6)
export const FONT_SIZE_S = responsiveFontSize(1.2)
export const FONT_SIZE = responsiveFontSize(1.6)
export const FONT_SIZE_L = responsiveFontSize(1.8)
export const FONT_SIZE_XL = responsiveFontSize(2)

export const FONT_FAMILY_LIGHTEST = 'ubuntu-lightest'
export const FONT_FAMILY_LIGHT = 'ubuntu-light'
export const FONT_FAMILY = 'ubuntu-medium'
export const FONT_FAMILY_BOLD = 'ubuntu-regular'
export const FONT_FAMILY_BOLDER = 'ubuntu-bold'
export const FONT_FAMILY_BOLDEST = 'ubuntu-bold'

export const INPUT_PLACEHOLDER_COLOR = hexToRGB(SUBTEXT_PRIMARY_COLOR, 0.5)
export const BUTTON_BORDER_COLOR = TEXT_PRIMARY_COLOR